<template>
    <div>
        <raw-page-header :title="title" @edit-raw-data="$_editRawData(FieldDataTableCode)" />

        <div v-if="rawData" class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="std-padding white-bg card">
                    <p class="sectionTitle">Raw Data</p>
                    <table id="carotene-detail-table" class="table">
                        <tr>
                            <th>No.</th>
                            <th>Title</th>
                            <th>Data</th>
                        </tr>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Palm ID</td>
                                <td>{{ rawData.palmTrialPalmId }}</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Status</td>
                                <td v-html="getStatusBtn(rawData)" />
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Flag</td>
                                <td v-html="getFlagData(rawData)" />
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Carotene</td>
                                <td>{{ addTo2Decimal(rawData.carotene) }}</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Record Date</td>
                                <td>{{ formatCreationTime(dateTimeValue) }}</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Created By</td>
                                <td>{{ (rawData.creatorUser||{}).userName || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="std-padding white-bg height100 card">
                    <p class="changes-history-title">Changes History</p>
                    <edit-history-table ref="historyTable" :field-data-name="FieldDataCategory" :raw-data-id="paramID" />
                </div>
            </div>
        </div>

        <general-dialog v-if="dynamicForm" :dialog.sync="editDialog" :header="editDialogHeader">
            <template #content>
                <dynamic-form ref="dynamicForm" 
                              :dynamic-form="dynamicForm"
                />

                <div class="dateTime-container">
                    <span class="demonstration">Record Date: </span>
                    <el-date-picker
                        v-model="dateTimeValue"
                        class="dateTime-input"
                        type="datetime"
                        placeholder="Select date and time"
                    />
                </div>
            </template>
            <template #action>
                <v-btn color="agrinome_primary" dark @click="updateData()">Update</v-btn>
            </template>
        </general-dialog>

        <general-dialog :dialog.sync="isConfirmDialog" :header="isConfirmDialogHeader">
            <template #content>
                Are you sure to update this?
            </template>
            <template #action>
                <v-btn color="agrinome_primary" dark @click="$_comfirmUpdateRawData(FieldDataCategory)">Yes</v-btn>
            </template>
        </general-dialog>

        <record-status-dialog 
            ref="recordDialog" 
            :api-info="ApiInfo" 
            :status-info="StatusInfo"
            :dialog.sync="dialog"
            :update-multiple="updateMultiple"
            @updated-success="updatedStatusSuccess()"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: null,
            paramID: null,
            title: "Carotene Raw Detail",

            editDialog: false,
            editDialogHeader: "Edit Carotene Raw",
            dynamicForm: null,

            isConfirmDialog: false,
            isConfirmDialogHeader: "Are you sure to update the data?",

            FieldDataCategory: "CaroteneData",
            FieldDataTableCode: "CAROTENE",

            dateTimeValue: null,

            rawData: null,

            dialog: false,
            ApiInfo: {
                Table: "CarotenedData",
                UpdateManyKey: "CaroteneDataList",
                RepopulateMeanApi: "RepopulateCaroteneDerivedData"
            },
            StatusInfo: null,
            updateMultiple: false,

            tableId: "#carotene-detail-table"
        };
    },
    computed: {
        CaroteneRawVariables() {
            return CaroteneRawVariable;
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.paramID = parseInt(this.$route.params.id);
            this.getRawData();
        });
    },
    methods: {
        updatedStatusSuccess() {
            this.getRawData();
            this.getHistoryData();
        },
        getFlagData(rawData) {
            var flagVariable = "caroteneFlaggedDatas";
            var flagLength = rawData[flagVariable].length;
            setTimeout(function() { $("[data-toggle=\"tooltip\"]").tooltip(); }, 500);
            return this.$_getFlagTooltip(rawData, flagLength, flagVariable);
        },
        getStatusBtn(data) {
            var self = this;
            var value = data.status ? data.status : "&nbsp;&nbsp;-&nbsp;&nbsp;";
            setTimeout(function() { self.$_tableStatus(self.tableId); }, 500);
            return this.$_getStatusBtn(data.id, value);
        },
        getRawData() {
            var self = this;
            axios({
                method: "GET",
                url: "CaroteneData/Get",
                cache: {
                    ignoreCache: true,
                },
                params: {
                    Id: this.paramID
                }
            })
                .then(function (response) {
                    self.rawData = response.data.result;
                    self.dateTimeValue = response.data.result.recordDate;
                });
        },
        updateData() {
            this.editDialog = false;
            this.isConfirmDialog = true;
        },
        getHistoryData() {
            this.$refs.historyTable.redrawTable();
        }
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Palm/PalmRawDetail/RawCaroteneDetail.vue